module.exports = __webpack_public_path__ + "img/yw.ababc75d.png";